import React from 'react';
import { Activity, TrendingUp, Users, Globe, Award, Calendar } from 'lucide-react';

const ActivitiesAndImpact = () => {
  const ongoingActivities = [
    "Awareness Program on the Origin and Cessation of Caste Discrimination",
    "BODHI VIHAR Development",
    "Dhamma Dheeksha Ceremonies",
    "Buddhism Lifestyle Activities",
    "Online Meditation Classes and Sessions",
    "Buddhist Self-Help Group",
    "Movement for Revival of Buddhism",
    "Dhammasevak Training",
    "Buddhist Retreat Activities",
    "CHIBUCON (Children Buddhist Conference)",
    "MMT Buddhist Matrimony",
    "BUDDHA AND HIS DHAMMA Conference",
    "DHAMMA TALK",
    "Vesak Poornima Celebration",
    "BUDDHA AND HIS DHAMMA Book Reading Session",
    "MUSICON (Buddhist Music Festival)",
    "ADW Hostel Students Empowerment Program (AAYES)",
    "ADW Students Career Guidance Programme",
    "Welfare Activities for Oppressed Community",
    "INDIAN CONSTITUTION and BUDDHISM Awareness Meeting",
    "FLYING JAIBHIM (Dheekshabhoomi Flight Pilgrimage)",
    "Prabuddhabharath 2030 Mission"
  ];

  const achievements = [
    { number: "200+", label: "Awareness Programs on Caste Discrimination", description: "Across various districts, taluks, and villages of Tamil Nadu" },
    { number: "100", label: "Dhamma Orations", description: "Buddhist philosophy lectures and teachings" },
    { number: "93", label: "Days of Book Reading", description: "Women's Wing - Buddha and His Dhamma study" },
    { number: "5", label: "CHIBUCON Conferences", description: "Next scheduled: May 23-24, 2026" },
    { number: "32", label: "Dhamma Sevaks Trained", description: "2 Full-time, 30 Part-time across Tamil Nadu" },
    { number: "1", label: "State-Level Conference", description: "Buddha and His Dhamma - 2 days conference conducted" }
  ];

  const collaborations = [
    {
      name: "IADF",
      fullName: "International Ambedkarite Doctors Forum",
      description: "Coordinating international Ambedkarite Buddhist doctors"
    },
    {
      name: "Buddhist Fraternity Council",
      fullName: "Buddhist Fraternity Council",
      description: "Joint state-level conferences and welfare activities"
    },
    {
      name: "NURTURE",
      fullName: "BHEL SC ST Employee's Welfare Organisation",
      description: "Career guidance and AAYES program coordination"
    },
    {
      name: "Savitribai Phule Trust",
      fullName: "Ms. Velicham Sherin",
      description: "Buddhist lifestyle training to converted Buddhists"
    },
    {
      name: "AIM",
      fullName: "Ambedkar International Mission",
      description: "International Buddhist-Ambedkarite network development"
    },
    {
      name: "AINS",
      fullName: "All India Nag Sangh",
      description: "Pan India Buddhist-Ambedkarist network creation"
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-blue-50 via-white to-orange-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-green-100 rounded-full mb-4">
            <Activity className="w-5 h-5 text-green-600" />
            <span className="text-sm font-semibold text-green-700">Making Real Impact</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our Activities & Impact
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto">
            Transforming lives through Buddhist revival and social empowerment across Tamil Nadu and beyond
          </p>
        </div>

        {/* Overall Impact Statistics */}
        <div className="mb-16 bg-gradient-to-r from-blue-600 via-purple-600 to-orange-600 rounded-2xl shadow-2xl p-8 md:p-12 text-white">
          <h3 className="text-3xl font-bold mb-8 text-center">MMT's Overall Impact</h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            <div className="text-center">
              <div className="text-5xl font-bold mb-2">12</div>
              <p className="text-lg text-blue-100">Years of Service</p>
            </div>
            <div className="text-center">
              <div className="text-5xl font-bold mb-2">10,000+</div>
              <p className="text-lg text-blue-100">Volunteers</p>
            </div>
            <div className="text-center">
              <div className="text-5xl font-bold mb-2">100,000+</div>
              <p className="text-lg text-blue-100">Lives Impacted</p>
            </div>
            <div className="text-center">
              <div className="text-5xl font-bold mb-2">200+</div>
              <p className="text-lg text-blue-100">Events Organized</p>
            </div>
          </div>
        </div>

        {/* Key Achievements */}
        <div className="mb-16">
          <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center flex items-center justify-center gap-3">
            <Award className="w-8 h-8 text-yellow-600" />
            Key Achievements
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {achievements.map((achievement, index) => (
              <div 
                key={index}
                className="bg-white rounded-xl shadow-lg p-6 transform hover:-translate-y-2 transition-all duration-300 border-t-4 border-blue-600"
              >
                <div className="text-5xl font-bold text-blue-600 mb-2">{achievement.number}</div>
                <h4 className="text-xl font-bold text-gray-900 mb-2">{achievement.label}</h4>
                <p className="text-gray-600">{achievement.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Ongoing Activities */}
        <div className="mb-16">
          <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center flex items-center justify-center gap-3">
            <TrendingUp className="w-8 h-8 text-green-600" />
            22 Ongoing Activities
          </h3>
          <div className="bg-white rounded-2xl shadow-2xl p-8 md:p-12">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {ongoingActivities.map((activity, index) => (
                <div 
                  key={index}
                  className="flex items-start gap-3 p-4 rounded-lg hover:bg-blue-50 transition-colors group"
                >
                  <div className="flex-shrink-0 w-8 h-8 bg-gradient-to-br from-blue-600 to-blue-700 rounded-full flex items-center justify-center text-white font-bold text-sm group-hover:scale-110 transition-transform">
                    {index + 1}
                  </div>
                  <p className="text-gray-800 font-medium leading-relaxed">{activity}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Dhamma Sevaks Network */}
        <div className="mb-16 bg-gradient-to-r from-orange-600 to-orange-700 rounded-2xl shadow-2xl p-8 md:p-12 text-white">
          <div className="text-center mb-8">
            <Users className="w-12 h-12 mx-auto mb-4" />
            <h3 className="text-3xl font-bold mb-4">Dhamma Sevaks Network</h3>
            <p className="text-xl text-orange-100">Spreading Buddhist teachings across Tamil Nadu</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto mb-8">
            <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl border border-white/20 text-center">
              <div className="text-4xl font-bold mb-2">32</div>
              <p className="text-orange-100">Trained Dhamma Sevaks</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl border border-white/20 text-center">
              <div className="text-4xl font-bold mb-2">2</div>
              <p className="text-orange-100">Full-time Sevaks</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl border border-white/20 text-center">
              <div className="text-4xl font-bold mb-2">30</div>
              <p className="text-orange-100">Part-time Sevaks</p>
            </div>
          </div>

          <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl border border-white/20">
            <h4 className="font-bold text-lg mb-3">Active Locations:</h4>
            <div className="flex flex-wrap gap-3">
              {["Tirunelveli", "Thiruchendur", "Kovilpatti", "Sathankulam", "Coimbatore", "Thoothukudi"].map((location, index) => (
                <span key={index} className="px-4 py-2 bg-white/20 rounded-full text-sm font-semibold">
                  {location}
                </span>
              ))}
            </div>
            <div className="mt-6 p-4 bg-orange-800/30 rounded-lg">
              <p className="text-sm text-orange-100 mb-2">
                <strong>3rd Training Program:</strong> June 20-21, 2025
              </p>
              <p className="text-xs text-orange-200 italic">
                Dhamma Sevakanang Sicca Vaso
              </p>
            </div>
          </div>
        </div>

        {/* Collaborations & Partnerships */}
        <div className="mb-16">
          <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center flex items-center justify-center gap-3">
            <Globe className="w-8 h-8 text-purple-600" />
            Collaborations & Partnerships
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {collaborations.map((collab, index) => (
              <div 
                key={index}
                className="bg-white rounded-xl shadow-lg p-6 hover:shadow-2xl transition-shadow border-l-4 border-purple-600"
              >
                <div className="bg-purple-100 text-purple-700 font-bold text-lg px-4 py-2 rounded-lg inline-block mb-3">
                  {collab.name}
                </div>
                <h4 className="font-bold text-gray-900 mb-2">{collab.fullName}</h4>
                <p className="text-gray-600 text-sm">{collab.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Special Programs */}
        <div className="bg-gradient-to-br from-blue-100 to-orange-100 rounded-2xl p-8 md:p-12">
          <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center flex items-center justify-center gap-3">
            <Calendar className="w-8 h-8 text-blue-600" />
            Special Initiatives
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-white p-6 rounded-xl shadow-md">
              <h4 className="text-xl font-bold text-blue-600 mb-3">AAYES Program</h4>
              <p className="text-gray-700 mb-2"><strong>Annal Ambedkar Youth Empowerment Scheme</strong></p>
              <p className="text-gray-600">Educating Buddhist lifestyle of Five Precepts and Eightfold Path to AD Welfare College Hostel inmates across Tamil Nadu. In partnership with NURTURE.</p>
            </div>
            
            <div className="bg-white p-6 rounded-xl shadow-md">
              <h4 className="text-xl font-bold text-orange-600 mb-3">Career Guidance Program</h4>
              <p className="text-gray-700 mb-2"><strong>For High School & Higher Secondary Students</strong></p>
              <p className="text-gray-600">MMT and NURTURE conducting career guidance classes across Tamil Nadu, empowering students from oppressed communities.</p>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-md">
              <h4 className="text-xl font-bold text-green-600 mb-3">Buddhist Lifestyle Training</h4>
              <p className="text-gray-700 mb-2"><strong>With Savitribai Phule Trust</strong></p>
              <p className="text-gray-600">Handholding Ms. Velicham Sherin in imparting Buddhist lifestyle training to converted Buddhists.</p>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-md">
              <h4 className="text-xl font-bold text-purple-600 mb-3">Prabuddhabharath 2030 Mission</h4>
              <p className="text-gray-700 mb-2"><strong>Vision for Enlightened India</strong></p>
              <p className="text-gray-600">Long-term mission to create an enlightened India through Buddhist revival and social transformation by 2030.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ActivitiesAndImpact;